<ng-container *transloco="let t; scope: 'featureSearch'">
  <bd-dialog
    data-id="edit-data-loading-dialog"
    [visible]="loading()"
    (dismiss)="onCancelLoading()"
    [dialogProperties]="loadingDialogProperties"
  >
    <div class="flex flex-col items-center justify-center px-[40px]">
      <p-progress-spinner
        data-id="edit-data-loading-spinner"
        [style]="{ width: '32px', height: '32px' }"
        strokeWidth="4"
        [attr.aria-label]="t('featureSearch.editData.loadingDialog.title')"
      />
      <div
        data-id="edit-data-loading-dialog-title"
        class="bd-headline-small mb-3 mt-6"
      >
        {{ t('featureSearch.editData.loadingDialog.title') }}
      </div>
      <div
        data-id="edit-data-loading-dialog-message"
        class="bd-body-large whitespace-pre-line text-center mb-8"
      >
        {{ t('featureSearch.editData.loadingDialog.message') }}
      </div>
      <p-button
        data-id="edit-data-loading-dialog-cancel-button"
        (onClick)="onCancelLoading()"
        [text]="true"
        [label]="t('featureSearch.editData.loadingDialog.cancelButtonLabel')"
      >
      </p-button>
    </div>
  </bd-dialog>

  @if (showWarning()) {
    <bd-status-dialog
      data-id="edit-data-warning-dialog"
      [dialogSettings]="store.warningDialogSettings()"
      (confirm)="onConfirm()"
      (dismiss)="onDismiss()"
    >
      @let isSingular = store.editableCount() === 1;

      <p class="bd-body-large mb-3">
        {{
          t('featureSearch.' + store.warningMessage(), {
            count: store.editableCount().toString(),
            pluralSuffix: isSingular ? '' : 's',
            isAre: isSingular ? 'is' : 'are',
          })
        }}
      </p>
      @if (store.warningDetails()) {
        <p class="bd-body-large">
          {{ t('featureSearch.' + store.warningDetails()) }}
        </p>
      }
    </bd-status-dialog>
  }
</ng-container>
